export enum TrainingModeStatus {
  Started = 'started',
  Finished = 'finished',
}
